import { Box, Dialog, DialogContent, withStyles } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CrossImg from "../../Assets/images/cross-icon.svg";
import { domainRenewalDetails, initiateDomainRenewal, toggleDomainRenewalModal } from "../../Redux/Actions";
import "./style.scss";
import { CURRENCY_SYMBOL } from "../../Config";
import moment from "moment";
import CTAButton from "../Common/CTAButton";
import { PAYMENT } from "../../Constants/routesConstant";
import history from "../../Utils/history";
import CountDownTimer from "../../Containers/DomainDetails/CountDownTimer";
import { RootState } from "../../Redux/Reducers";
import { getRenewalYears } from "../DomainUpsellModalNew/utils";
import {
  DOMAIN_DEACTIVATED_OUT_OF_GRACE_PERIOD_STATUS,
  DOMAIN_PURCHASE_EXTERNAL_SOURCE,
  EXTERNAL_DOMAIN_PURCHASED_SUBSCRIPTION_ID,
  NORMAL_DOMAIN_PURCHASE_TYPE,
  OUT_OF_GRACE_PERIOD_PURCHASE_TYPE,
  PURCHASED_DOMAIN_SUBSCRIPTION_ID,
} from "../../Utils/constants";

const CustomDialog = withStyles({
  root: {
    "& .MuiDialog-paperWidthMd": {
      maxWidth: 554,
      width: "100%",
      borderRadius: 8,
    },
  },
})(Dialog);

const CustomDialogContent = withStyles({
  root: {
    padding: "32px 40px",
    "&:first-child": {
      paddingTop: 64,
    },
  },
})(DialogContent);

const yearArr = ["1 Year", "2 Years", "3 Years", "4 Years", "5 Years"];

const DomainRenewalModal = () => {
  const dispatch = useDispatch();
  const [year, setYear] = useState(1);
  const [timeLeft, setTimeLeft] = useState({});

  const { domainRenewalDetail, domainRenewalModalView } = useSelector((state: RootState) => ({
    domainRenewalDetail: state.domainReducer.domainRenewalDetail,
    domainRenewalModalView: state.commonReducer.domainRenewalModalView,
  }));

  /**
   * Revert year to 1 after modal closes
   */
  useEffect(() => {
    if (!domainRenewalModalView) {
      setYear(1);
    }
  }, [domainRenewalModalView]);

  const selectYear = (e: any) => {
    const year = parseInt(e.target.value);
    setYear(year);
    const data = {
      domain: domainRenewalDetail?.domain_name,
      year: year,
    };
    dispatch(domainRenewalDetails({ ...data }));
  };
  const years = getRenewalYears(domainRenewalDetail);

  const calculateTotalPrice = () => {
    const total =
      (domainRenewalDetail?.renewal_price || 0) +
      (domainRenewalDetail?.annual_static_charges || 0) -
      (domainRenewalDetail?.discount || 0);
    return total;
  };

  const closeDomainRenewalModal = () => {
    dispatch(toggleDomainRenewalModal(false));
  };
  const checkSourceExternal = () => domainRenewalDetail?.source === DOMAIN_PURCHASE_EXTERNAL_SOURCE;
  const onClickProceedToPay = () => {
    const payload = {
      domain: domainRenewalDetail?.domain_name,
      purchase_price: domainRenewalDetail?.coupon_id ? domainRenewalDetail?.renewal_price : calculateTotalPrice(),
      year: year,
      purchase_type:
        checkSourceExternal() && domainRenewalDetail?.status === DOMAIN_DEACTIVATED_OUT_OF_GRACE_PERIOD_STATUS
          ? OUT_OF_GRACE_PERIOD_PURCHASE_TYPE
          : NORMAL_DOMAIN_PURCHASE_TYPE,
      subscription_id: checkSourceExternal()
        ? EXTERNAL_DOMAIN_PURCHASED_SUBSCRIPTION_ID
        : PURCHASED_DOMAIN_SUBSCRIPTION_ID,
      coupon_id: domainRenewalDetail?.coupon_id,
      coupon_discount: domainRenewalDetail?.discount,
    };
    dispatch(
      initiateDomainRenewal(payload, (status: any) => {
        closeDomainRenewalModal();
        status && history.push(PAYMENT);
      }),
    );
  };

  const savedomainTimer = (data: any) => {
    setTimeLeft(data);
  };

  const countDownProp: any = {
    savedomainRenewalExpiry: (data: any) => savedomainTimer(data),
    timeLeft: timeLeft,
  };

  return (
    <CustomDialog open={domainRenewalModalView} maxWidth="md">
      <CustomDialogContent className="domain-renewal-modal">
        <img src={CrossImg} className="close-img pointer" onClick={closeDomainRenewalModal} />
        <Box className="flex items-center justify-between" paddingBottom="56px">
          <Box component="h2" flex="0 1 auto" className="mv0 md-text32 fw6 break-word pr3">
            {domainRenewalDetail?.domain_name}
          </Box>
          <Box className="md-text16 fw6">
            <select
              id="account"
              className="fw5 md-text16 pointer domain-year-select"
              onChange={(e) => selectYear(e)}
              value={year}
            >
              {yearArr.map((yr, index) => {
                return (
                  <option value={index + 1} key={index} className="fw6 md-text16 ">
                    For {yr}
                  </option>
                );
              })}
            </select>
          </Box>
        </Box>
        <Box className="main-section">
          <Box className="flex justify-between ds-mb24">
            <Box>
              <div className="md-text14 fw6">Domain Renewal Price: </div>
              <div className="md-text12 o-60 fw4">For {yearArr[years > 0 ? years - 1 : 0]}</div>
            </Box>
            <Box className="md-text14">
              {CURRENCY_SYMBOL}
              {domainRenewalDetail?.renewal_price}
            </Box>
          </Box>
          <Box className="flex justify-between ds-mb24">
            <Box className="md-text14 fw6">Hosting + SSL</Box>
            {domainRenewalDetail?.annual_static_charges ? (
              <Box className="fw5 md-text14">
                {CURRENCY_SYMBOL}
                {domainRenewalDetail?.annual_static_charges}
              </Box>
            ) : (
              <Box className="white md-text12 ds-bg32C92F fw6 br1" padding="2px 3px">
                FREE
              </Box>
            )}
          </Box>
          {!!domainRenewalDetail?.discount && (
            <Box className="flex items-center justify-between">
              <Box className="md-text14 fw6" color="#009B45">
                Renewal Discount
              </Box>
              <Box className="md-text14 fw5">
                -{CURRENCY_SYMBOL}
                {domainRenewalDetail?.discount}
              </Box>
            </Box>
          )}
        </Box>
        {!!domainRenewalDetail?.discount && (
          <Box className="w-100 ds-mb24" border="1px solid #E0E0E0" padding="10px 0" borderRadius="8px">
            <CountDownTimer {...countDownProp} />
          </Box>
        )}

        <Box className="ds-mb48 flex justify-end">
          <Box className="fw6 pr3" component="span">
            Total: {CURRENCY_SYMBOL}
            {calculateTotalPrice()}
          </Box>
        </Box>
        <Box className="flex items-center justify-between">
          <Box className="dib">
            <div className="o-50 md-text14">Validity:</div>
            <div className="md-text14 fw6">
              {moment(domainRenewalDetail?.renewal_start_date).format("MMM DD, YYYY")} to{" "}
              {moment(domainRenewalDetail?.renewal_end_date).format("MMM DD, YYYY")}
            </div>
          </Box>
          {!!domainRenewalDetail?.domain_name && (
            <Box>
              <CTAButton customClasses="ds-pv12 ds-pl42 ds-pr42" onClick={onClickProceedToPay}>
                Complete Payment
              </CTAButton>
            </Box>
          )}
        </Box>
      </CustomDialogContent>
    </CustomDialog>
  );
};

export default DomainRenewalModal;
